/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PolicyData {
    getFixupPrototypeFunction() { return PolicyData.fixupPrototype; }

    static newInstance(model: Partial<PolicyData>): PolicyData {
        let obj = Object.assign(new PolicyData(), model);
        PolicyData.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PolicyData>): PolicyData {
        if (!model) return null;
        return PolicyData.newInstance(<PolicyData> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PolicyData) {
        if (!obj) return;

        models.PolicyData.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PolicyData): boolean {
        Object.setPrototypeOf(obj, PolicyData.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * unique policy Id returned
     */
    policy_id: string;

}
